import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './messenger-box.css';

export class MessengerBox extends Component {
  static propTypes = {
    title: PropTypes.string
  }
  constructor(props) {
    super(props);
    this.state = { title: '', body: '', fn: null, btnYes: 'Yes', btnNo: 'No' };
    this.confirm = (title, body, fn, btnYes, btnNo) => {

      const title1 = (title === null || title === '') ? this.state.title : title;

      const btnYes1 = (btnYes === null || btnYes === '' || typeof (btnYes) === 'undefined') ? this.state.btnYes : btnYes;

      const btnNo1 = (btnNo === null || btnNo === '' || typeof (btnNo) === 'undefined') ? this.state.btnNo : btnNo;

      this.setState({ title: title1, body: body, fn: fn, btnYes: btnYes1, btnNo: btnNo1 });

      $('#msg-box').modal({ show: 'false', backdrop: 'static', keyboard: false });
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ title: nextProps.title });
  }

  render() {
    return <div id='msg-box' className='modal fade in' role='dialog'>
      <div className='modal-dialog modal-sm'>
        <div className='modal-content msg-box-content'>
          <div className='modal-body'>
            <p>{this.state.body}</p>
          </div>
          <div className='modal-footer'>
            <button type='button' className='button flat' data-dismiss='modal'>{this.state.btnNo}</button>
            <button type='button' className='button raised danger' data-dismiss='modal' onClick={this.state.fn} style={{marginLeft: 10}}>{this.state.btnYes}</button>
          </div>
        </div>
      </div>
    </div>;
  }
}




// WEBPACK FOOTER //
// ./src/components/messenger-box/messenger-box.js